import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { Button } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import 'react-day-picker/style.css';
import { ChevronLeftIcon, ChevronRightIcon } from '@/icons';
import { cn } from '@/utils';
export type CalendarProps = React.ComponentProps<typeof DayPicker>;
const CalendarChevron = (params: {
  orientation?: 'up' | 'down' | 'left' | 'right';
}) => params.orientation === 'left' ? <ChevronLeftIcon size={'xs'} fill={ICON_COLOR.neutral} /> : <ChevronRightIcon size={'xs'} fill={ICON_COLOR.neutral} />;
const CalendarMonthButton = (params: React.ComponentProps<typeof Button>) => <Button intent={'neutral'} variant={'transparent'} size={'xs'} {...params} data-sentry-element="Button" data-sentry-component="CalendarMonthButton" data-sentry-source-file="calendar.tsx" />;
const CALENDAR_COMPONENTS = {
  Chevron: CalendarChevron,
  NextMonthButton: CalendarMonthButton,
  PreviousMonthButton: CalendarMonthButton
};
export function Calendar({
  className,
  classNames,
  navLayout,
  locale,
  ...props
}: CalendarProps) {
  return <DayPicker className={cn('p-md min-w-[328px] flex', className)} locale={locale} components={CALENDAR_COMPONENTS} classNames={{
    months: 'w-full',
    weekday: 'size-[36px] text-body-md-semibold text-default',
    month_caption: 'flex h-[42px] items-center',
    caption_label: 'text-body-lg-semibold text-default',
    month_grid: 'w-full border-spacing-none mt-[10px]',
    day: cn('size-[36px] p-none text-body-md-semibold rounded-full hover:bg-[rgba(28,_27,_31,_0.04)] data-disabled:hover:bg-transparent text-default ' + 'aria-selected:!text-inverse aria-selected:hover:bg-primary'),
    day_range_end: 'day-range-end',
    selected: 'bg-strong rounded-full text-inverse',
    day_selected: 'bg-primary hover:bg-strong !text-inverse rounded-full',
    day_today: 'text-strong aria-selected:!text-inverse aria-selected:bg-primary',
    day_outside: 'text-disabled ',
    day_disabled: 'text-disabled ',
    // day_button: 'text-inverse',
    day_range_middle: 'aria-selected:bg-slate-100 aria-selected:text-slate-900',
    day_hidden: 'invisible',
    ...classNames
  }} {...props} data-sentry-element="DayPicker" data-sentry-component="Calendar" data-sentry-source-file="calendar.tsx" />;
}
Calendar.displayName = 'Calendar';